var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9119 8.61328C25.8841 8.79142 25.8533 8.97262 25.8166 9.15932C24.5873 15.4726 20.3803 17.6552 15.0073 17.6552H12.2713C11.6149 17.6552 11.0607 18.1331 10.9583 18.7815L9.16005 30.1824C9.09313 30.6071 9.42161 30.9915 9.85154 30.9915H14.7036C15.2777 30.9915 15.7666 30.5738 15.8562 30.0064L15.9038 29.7598L16.8178 23.9639L16.8767 23.6436C16.9663 23.0762 17.4552 22.6585 18.0293 22.6585H18.755C23.4555 22.6585 27.136 20.7487 28.2116 15.226C28.6608 12.9184 28.4286 10.9921 27.2402 9.63783C26.8809 9.22838 26.4335 8.88951 25.9119 8.61328Z",
    fill: "#2790C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5561 8.65283C12.6175 8.26263 12.8677 7.94331 13.2048 7.78167C13.3582 7.70834 13.5293 7.66739 13.7087 7.66739H21.0174C21.8834 7.66739 22.6907 7.72423 23.4289 7.84309C23.6398 7.87701 23.8448 7.91612 24.0443 7.96042C24.2439 8.00473 24.4373 8.05393 24.6246 8.10893C24.7184 8.13612 24.8104 8.16485 24.9011 8.1951C25.2635 8.31549 25.6009 8.45727 25.9113 8.62166C26.2774 6.28808 25.9089 4.70007 24.6466 3.26178C23.2569 1.67835 20.7464 1 17.5343 1H8.21005C7.5537 1 6.99482 1.4776 6.89246 2.126L3.00997 26.7461C2.93327 27.232 3.30881 27.6711 3.80046 27.6711H9.55666L12.5561 8.65283Z",
    fill: "#27346A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6249 8.1056C24.4376 8.0506 24.2442 8.0014 24.0447 7.9571C23.8451 7.91279 23.6401 7.87368 23.4293 7.83976C22.691 7.7209 21.8837 7.66406 21.0178 7.66406H13.709C13.5296 7.66406 13.3585 7.70501 13.2051 7.77834C12.8681 7.93999 12.6178 8.2593 12.5564 8.6495L11.0029 18.499L10.958 18.7866C11.0604 18.1382 11.6147 17.6603 12.271 17.6603H15.007C20.3801 17.6603 24.587 15.4776 25.8163 9.16438C25.853 8.97768 25.8839 8.79648 25.9117 8.61834C25.6012 8.45394 25.2639 8.31216 24.9015 8.19177C24.8107 8.16152 24.7187 8.1328 24.6249 8.1056Z",
    fill: "#1F264F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.74086a00b368e29f734487f27988eee8.svg";
export { ForwardRef as ReactComponent };